module.exports = __webpack_public_path__ + "static/media/doll_icon.e2cb53cf.png";